exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-page-details-js": () => import("./../../../src/templates/page-details.js" /* webpackChunkName: "component---src-templates-page-details-js" */),
  "component---src-templates-pdf-page-template-js": () => import("./../../../src/templates/pdf-page-template.js" /* webpackChunkName: "component---src-templates-pdf-page-template-js" */)
}

